type TooltipController = {
  hide: () => void;
  show: () => void;
};

let activeTooltip: TooltipController | null = null;
let parentTooltip: TooltipController | null = null;
let parentBoundary: HTMLElement | null = null;

export const setActiveTooltip = (controller: TooltipController, boundary?: HTMLElement | null) => {
  if (activeTooltip === controller) {
    controller.show();
    return;
  }

  if (activeTooltip) {
    activeTooltip.hide();
    if (!parentTooltip) {
      parentTooltip = activeTooltip;
    }
  } else if (boundary) {
    parentBoundary = boundary;
  }

  activeTooltip = controller;
  controller.show();
};

export const clearActiveTooltip = (controller: TooltipController, relatedTarget: EventTarget | null = null) => {
  controller.hide();

  if (activeTooltip !== controller) return;

  activeTooltip = null;

  if (!parentTooltip) {
    parentBoundary = null;
    return;
  }

  const enteredParent = parentBoundary && relatedTarget instanceof Node && parentBoundary.contains(relatedTarget);

  if (enteredParent) {
    activeTooltip = parentTooltip;
    parentTooltip.show();
  } else {
    parentTooltip.hide();
  }

  parentTooltip = null;
  parentBoundary = null;
};

/** Clears tooltip lock state after overlays (e.g. modals) that skip pointer leave events. */
export const resetTooltips = () => {
  activeTooltip?.hide();
  parentTooltip?.hide();
  activeTooltip = null;
  parentTooltip = null;
  parentBoundary = null;
};
